import { LocaleId } from '@domgen/dgx-fe-i18n';
import { TranslationDictionaryMapping } from '@domgen/dgx-fe-i18n/lib/models/translation-dictionary/translation-dictionary-mapping.type';
import { FeatureArticleSearchTranslationDictionary } from '@self-fix/util-models';

export const ArticleSearchTranslation: TranslationDictionaryMapping<FeatureArticleSearchTranslationDictionary> =
  {
    [LocaleId.English_GreatBritain]: {
      ARTICLE_SEARCH_RESULTS_TITLE: 'Search results',
    },
    [LocaleId.English_Ireland]: {
      ARTICLE_SEARCH_RESULTS_TITLE: 'Search results',
    },
    [LocaleId.English_US]: {
      ARTICLE_SEARCH_RESULTS_TITLE: 'Search results',
    },
  };
